import React, {useState, useEffect, useRef, useLayoutEffect, setState, prevState } from 'react';
import { Container, Row, Col, Form, Button, Spinner, Alert, Card, Dropdown } from 'react-bootstrap';
import { userModification, getSingleUser } from "./UserModifyAction";
import { getAllUserRole } from "../userRole/allUserRoleActions";
import { useDispatch, useSelector } from "react-redux";
import { useParams , useNavigate, Link} from 'react-router-dom';
import { useForm } from "react-hook-form";
import Swal from "sweetalert2";
import { FaEdit, FaTrash, FaPlus, FaArrowLeft } from 'react-icons/fa';
import { isDisabled } from '@testing-library/user-event/dist/utils';


const passVerificationError = {
  isLenthy: false,
  hasUpper: false,
  hasLower: false,
  hasNumber: false,
  hasSpeclChr: false,
  confirmPassword: true
};

const UserModify = () => {
  let navigate = useNavigate();
  const dispatch = useDispatch();
  const {id}=useParams();
  const {profile}=useParams();
  console.log('profile',profile);
  const UserRef = useRef(null);
  //const [alertStatus, setAlertStatus] = useState('');
  const { register, handleSubmit, formState: { errors } } = useForm();
  const [passwordError, setPasswordError] = useState(passVerificationError);
  const {isloading, umstatus, ummessage} = useSelector((state) => state.userModify);
  const { userRoles }= useSelector((state) => state.allUserRoles);
  const userData = useSelector((state) => state.userModify);

 
  const uData = JSON.parse(JSON.stringify(userData.userSDetail));
 // console.log(uData.supplier_name);
 console.log(uData);
 console.log(userData);
 console.log(userRoles);
 

  const [userName,setUserName]= useState('');
  const [contactNo,setContactNo]= useState('');
  const [email,setEmail]= useState('');
  const [password,setPassword]= useState('');
  console.log("password",password)
  const [address,setAddress]= useState('');
  const [addressTwo,setAddressTwo]= useState('');
  const [roleId,setRoleId]= useState('');
  const [userStatus,setUserStatus]= useState('');
  const [avatar, setAvatar]= useState("");
  const [modify, setModify] = useState(0);
  const [contactNoError, setContactNoError] = useState(false);
  const [emailError, setEmailError] = useState(false);
  const [nameError, setNameError] = useState(false);
  const [users, setUsers] = useState({
    id:"",
    username:"",
    contactno:"",
    email:"",
    address:"",
    addresstwo:"",
    role_id:"",
    user_status:""
  });
  const [userRole, setUserRole] = useState("");
  

 
  
  const firstUpdate = useRef(true);
  useLayoutEffect(() => {
    if (firstUpdate.current) {
      firstUpdate.current = false;
      loadUser(id);
      return;
    }

   
  });
   useEffect(() => { 
    console.log('useEffect');
    loadUser(id);
     setUsers({id:"",username:"",contactno:"",email:"",role_id:"",address:"",addresstwo:"",user_status:""});
   
     }, []);
     function loadUser(id){
       // console.log('load supplier'+ id)
        dispatch(getSingleUser(id));
        dispatch(getAllUserRole());
        setUsers({id:uData.id,username:uData.username,contactno:uData.contactno,email:uData.email,role_id:uData.role_id,address:uData.address,addresstwo:uData.address_two,user_status:uData.user_status,avatar:uData.user_image});

      }

      const handleFileSelect = (e) =>{
        const name = e.target.name;
        const value = e.target.files[0] ;
        setAvatar(e.target.files[0]);
        setUsers({ ...users, [name]: value });
       setAvatar(e.target.files[0]);
      }
   
    
  
      const handleOnChange = (e) => {
        const name = e.target.name;
        const value = e.target.value;
        console.log('name ' + name);
        console.log('value ' + value);
        console.log(users);

        if (name === "contactno") {
          if (!/^\d+$/.test(value) || (value.length < 10 || value.length >= 15)) {
            setContactNoError('Enter a valid mobile number');
          } else {
            setContactNoError('');
          }
        }
        if (name === "email") {
          if (value.includes("@")) {
            setEmailError(false);
          } else {
            setEmailError(true);
          }
        }
    
        if (name === "username") {
          if (!/^[a-zA-Z]+$/.test(value)) {
            setNameError('Enter valid supplier name');
          } else {
            setNameError('');
          }
        }
      
        if (name === "password" && value === "") {
          // Skip password validation if the field is empty
          setUsers({ ...users, [name]: value });
        } else {
          setUsers({ ...users, [name]: value });
      
          if (name === "password") {
            const isLenthy = value.length > 8;
            const hasUpper = /[A-Z]/.test(value);
            const hasLower = /[a-z]/.test(value);
            const hasNumber = /[0-9]/.test(value);
            const hasSpeclChr = /[@,#,$,%,&]/.test(value);
            setPasswordError({
              ...passwordError,
              isLenthy,
              hasUpper,
              hasLower,
              hasNumber,
              hasSpeclChr,
              confirmPass: users.password === value,
            });
          }
      
          if (name === "confirmPassword") {
            setPasswordError({
              ...passwordError,
              confirmPass: users.password === value,
            });
          }
        }
      };
      
      
      
  
  const handleOnSubmit = (e) => {
    e.preventDefault();
  
    const {
      username,
      contactno,
      email,
      role_id,
      password,
      address,
      addresstwo,
      user_status,
      avatar
    } = users;
  
    // Check if the password and confirm password fields are not empty
    const passwordNotEmpty = password !== "" && users.confirmPassword !== "" && password !== undefined && users.confirmPassword !== undefined;
  
    // Check if the password fields don't match or fail the validation
    const passwordMismatch =
      passwordNotEmpty && password !== users.confirmPassword;
  
    const passwordValidationError =
      passwordNotEmpty &&
      (!passwordError.isLenthy ||
        !passwordError.hasUpper ||
        !passwordError.hasLower ||
        !passwordError.hasNumber ||
        !passwordError.hasSpeclChr);
  
    if (passwordMismatch || passwordValidationError) {
      // Show password validation failed error
      Swal.fire("Password validation failed!", "", "error");
      return;
    }
  
    let formData1 = new FormData();
    formData1.append("id", id);
    formData1.append("username", username);
    formData1.append("contactno", contactno);
    formData1.append("email", email);
    formData1.append("role_id", role_id);
    if (password === undefined) {
      formData1.append("password1", uData?.password);
    } else {
      formData1.append("password", password);
    }
  
    formData1.append("address", address);
    formData1.append("address_two", addresstwo);
    formData1.append("status", user_status);
    formData1.append("avatar", avatar);
  
    if (
      username !== "" ||
      contactno !== "" ||
      email !== "" ||
      email !== "" ||
      role_id !== "" ||
      address !== "" ||
      addresstwo !== "" ||
      user_status !== "" ||
      password !== undefined ||
      avatar !== undefined
    ) {
      dispatch(userModification(formData1));
  
      setModify(1);
      navigate("/modifyUser/" + id);
      Swal.fire("User field updated Successfully!", "", "success");
      navigate("/allUsers");
    } else {
      Swal.fire("No changes made!", "", "warning");
      navigate("/allUsers");
      return;
    }
  };
  
  const isDisabled = nameError || emailError || contactNoError ;
  const canSave = Boolean (userName) && Boolean(contactNo) && Boolean(email) && Boolean(address)  && Boolean(addressTwo)  && Boolean(userStatus)

console.log(users);


  return (
    <>
    {/* <Container className="my-4 mx-4 container-xl">
    
    <Card  style={{marginLeft:'100px',marginTop:'-60px'}}>
      <Card.Header><h4 className="d-flex text-dark text-left mt-2 mb-2">User Details Modify</h4></Card.Header>
      <Card.Body>
      <Row>
              <Col>
      
              <Link to="/allUsers"><span className="badge bg-success" style={{backgroundColor:'rgb(156 186 237)',color:'white'}}><FaArrowLeft />&nbsp;Go Back</span></Link> 
   
              <br />
              </Col>
            </Row> */}
            <div className="my-4  container-xl">
                <div className="card" style={{marginTop:'-80px'}}>
                    <div className="card-header">
                        <h3 className="d-flex text-dark text-left mt-2 mb-2"  style={{fontFamily:'Times New Roman' , fontWeight:'600'}}>User Details Modify</h3>
                    </div>
                    <div className="card-body">
                        <Row>
                          <Col>
                            <Link to="/allUsers"><span className="badge bg-success" style={{backgroundColor:'rgb(156 186 237)',color:'white'}}><FaArrowLeft />&nbsp;Go Back</span></Link> 
                            </Col>
                        </Row>
                        <br />
      <Form className=" mx-4 my-2" component="form" noValidate onSubmit={e => handleSubmit(handleOnSubmit(e))}>

        <Row className="mb-3">
      <Form.Group as={Col} controlId="formGridUsername">
          <Form.Label>User Name</Form.Label>
          <Form.Control type="hidden" name="id" autoComplete='off' value={id} />
          <Form.Control type="text" ref={UserRef} required name="username" maxLength={50}  autoComplete='off' placeholder="Enter Username"  value={users.username ? users.username : uData.username} {...register("username", { required: true, mixLength: 3 })} onChange={handleOnChange} /> 
         {nameError && <p className='text-danger'>Enter valid user name</p>}
        </Form.Group>

        <Form.Group as={Col} controlId="formGridContactNo">
          <Form.Label>Contact No</Form.Label>
          <Form.Control type="text" required name="contactno" placeholder="Contact No" value={users.contactno ? users.contactno : uData.contactno} {...register("contactno", { required: true, mixLength: 3 })} onChange={handleOnChange}  />
        {contactNoError && <p className='text-danger'> Please enter a valid contact number containing only digits</p>}
        </Form.Group>
        </Row>
      <Row className="mb-3">
        <Form.Group as={Col} controlId="formGridEmail">
          <Form.Label>Email Address</Form.Label>
          <Form.Control type="email" maxLength={40} required name="email" placeholder="Enter email"  value={users.email ? users.email : uData.email} {...register("email", { required: true, mixLength: 3 })} onChange={handleOnChange}/>
        {emailError && <p className='text-danger'>Enter valid email</p>}
        </Form.Group>
        <Form.Group as={Col} controlId="formGridUserRole">
          <Form.Label>User Role</Form.Label>
        
        
          <Form.Select  required name="role_id" value={users.role_id  ? users.role_id : uData.role_id } 
          {...register("role_id", { required: true, mixLength: 3 })} onChange={handleOnChange} disabled={!!profile} > 
          {userRoles.map((urole,index) =>
        
          <option key={urole.id} value={urole.id}  >{urole.user_role}</option>
          )}
        </Form.Select>

        </Form.Group>
        </Row>
        <Row className="mb-3">
                <Form.Group as={Col} controlId="formGridPassword">
                  <Form.Label>Password</Form.Label>
                  <Form.Control type="password" required name="password" autoComplete='off' placeholder="Password" onChange={handleOnChange}/>
                </Form.Group>
                <Form.Group as={Col} controlId="formGridConfirmPassword">
                  <Form.Label>Confirm Password</Form.Label>
                  <Form.Control type="password" required name="confirmPassword" placeholder="Confirm Password" onChange={handleOnChange}/>
                  <Form.Text>
                    
                    {!passwordError.confirmPass && (
                      <div className="text-danger mb-3">Password doesn't match</div>
                    )}
                  </Form.Text>
                </Form.Group>

              </Row>
      <Row className="mb-3">
      <Form.Group as={Col}  controlId="formGridAddress1">
        <Form.Label>Address</Form.Label>
        <Form.Control type="text" placeholder="1234 Main St" maxLength={60} required name="address"  value={users.address ? users.address : uData.address} {...register("address", { required: true, mixLength: 3 })} onChange={handleOnChange} />
      </Form.Group>

      <Form.Group as={Col} controlId="formGridAddress2">
        <Form.Label>Address 2</Form.Label>
        <Form.Control type="text" placeholder="Apartment, studio, or floor" required name="addresstwo" maxLength={60} value={users.addresstwo ? users.addresstwo : uData.address_two} {...register("addresstwo", { required: true, mixLength: 3 })} onChange={handleOnChange} />
      </Form.Group>
      </Row>
      <Row className="mb-3">
      <Form.Group as={Col} controlId="formGridStatus">
          <Form.Label>Status </Form.Label>
          <Form.Select   value={users.user_status ? users.user_status : uData.user_status} required name="user_status" {...register("user_status", { required: true, mixLength: 3 })} onChange={handleOnChange}>
          
            <option value="1" >Enable</option>
            <option value="0"  >Disable</option>
          </Form.Select>
        </Form.Group>
        </Row>
        <Row className="mb-3">
        <Form.Group controlId="formFile" className="mb-3">
            <Form.Label>Upload Profile Image</Form.Label>
            <Form.Control type="file" required name="avatar"  onChange={(e) => handleFileSelect(e)}/>
         
      </Form.Group>
        <ul className="mab-4 mt-3">
            <li className={
                passwordError.isLenthy ? "text-success" : "text-danger"
            }> Min 8 Characters</li>
            <li 
            className={
                passwordError.hasUpper ? "text-success" : "text-danger"
            
            }>
                At least one upper case
            </li>
            <li 
            className={
                passwordError.hasLower ? "text-success" : "text-danger"
            }>
                At least on lower case
            </li>
            <li 
            className={
                passwordError.hasNumber ? "text-success" : "text-danger"
            }
            >
                At least one number
            </li>
            <li 
            className={
                passwordError.hasSpeclChr ? "text-success" : "text-danger"
            }
            >
                At least one of the special characters i.e @ # $ % & {" "}
            </li>
        </ul>
      </Row>

      <Button variant="primary" type="submit" disabled={isDisabled}>
        Submit
      </Button>
      {isloading && (<Spinner variant='info' animation='border'/>)}
      
    </Form>
     </div>
     </div>
     </div>
    </>
  );
}

export default UserModify;